/* Keep the crawlable locale links aligned with the URL the customer is viewing. */
(() => {
  'use strict';

  const historyApi = window.history;
  const linkSelector = '[data-language-switch]';

  function syncLinks() {
    const current = window.location;
    const currentOrigin = current.origin || new URL(current.href).origin;

    document.querySelectorAll(linkSelector).forEach(link => {
      const href = link.getAttribute('href');
      if (!href) return;

      try {
        const target = new URL(href, current.href);
        target.search = current.search;
        target.hash = current.hash;
        const nextHref = target.origin === currentOrigin
          ? `${target.pathname}${target.search}${target.hash}`
          : target.href;
        link.setAttribute('href', nextHref);
      } catch (e) {
        // Leave an invalid server-rendered href alone so the language link remains usable.
      }
    });
  }

  function watchHistory(method) {
    const original = historyApi[method];
    if (typeof original !== 'function' || original.__primeLanguageSwitch) return;

    const wrapped = function (...args) {
      const result = original.apply(this, args);
      syncLinks();
      return result;
    };
    wrapped.__primeLanguageSwitch = true;
    historyApi[method] = wrapped;
  }

  watchHistory('replaceState');
  watchHistory('pushState');
  window.addEventListener('popstate', syncLinks);
  window.addEventListener('hashchange', syncLinks);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncLinks);
  else syncLinks();
})();
